import { useMemo } from "react";
import { useRouter } from "next/router";
import Head from "next/head";
import { getLocalizedPathname } from "modules/localize-pathnames/getLocalizedPathname";

import { BASE_URL, I18nLocale } from "constants/enum";

export interface CanonicalServiceProps {
    /** When set (e.g. from CMS page SEO), use this instead of deriving from router. Single source for canonical. */
    overrideCanonicalUrl?: string | null;
}

export const CanonicalService: React.FunctionComponent<
    CanonicalServiceProps
> = ({ overrideCanonicalUrl }) => {
    const { asPath, locale = `${I18nLocale.SPAIN_ES}` } = useRouter();

    const derivedCanonicalUrl = useMemo(() => {
        const localizedPath = getLocalizedPathname(
            asPath.slice(1),
            locale as I18nLocale
        );
        const url = new URL(`${BASE_URL}/${locale}${localizedPath || asPath}`);
        const urlString = `${url.origin}${url.pathname}`;
        return urlString.endsWith("/") ? urlString.slice(0, -1) : urlString;
    }, [locale, asPath]);

    const canonicalUrl = overrideCanonicalUrl ?? derivedCanonicalUrl;

    return canonicalUrl ? (
        <Head>
            <link rel="canonical" key="canonical" href={canonicalUrl} />
        </Head>
    ) : null;
};
